/*                                                  */
/*                                                             */

import type { CarouselPattern } from "./carousel/src";
import type { EventAcceptWrapper } from "./common/src/pattern/head";

/*     */
import type { Pali } from "./head";

export * from "./carousel/src/index";
export type {
  DropDownEvents,
  Pali,
  Presets,
  Sheet,
  SheetCloseTypes,
  SheetEvents,
  Slider,
  SliderElement,
  SliderEvents,
  SnackbarEvents,
  SnackbarSettings,
  TextExpanderEvents,
  TooltipEvents,
} from "./head";

export interface GlobalPattern {
  carousel: EventAcceptWrapper<CarouselPattern>;
  /*                               */
}

declare global {
  interface OttoGlobal {
    /**
 *
 *
 *
 *
 *
 */
    pali: Pali;
  }

  interface Window {
    o_pattern: GlobalPattern;
  }
}

try {
  window.o_global.events().once("assets.events.allJavascriptLoaded", () => {
    if (window.o_util.toggle.get("ASSETS_LEGACY_Illustrations", false)) {
      const deprecatedIllustrations = document.querySelectorAll(
        [
          "https:/*                                  */
          "https:/*                           */
          "https:/*                             */
          "https:/*                       */
          "https:/*                             */
          "https:/*                           */
          "https:/*                          */
          "https:/*                           */
          "https:/*                                  */
          "https:/*                               */
          "https:/*                               */
          "https:/*                               */
          "https:/*                            */
          "https:/*                                   */
          "https:/*                                  */
          "https:/*                                                */
        ]
          .map((url) => `[src^='${url}']`)
          .join(",")
      );

      if (deprecatedIllustrations.length > 0) {
        window.AS.RUM.sendCustomRequest("AssetsLegacyIllustrations", {
          count: deprecatedIllustrations.length,
          data: JSON.stringify({
            findings: [...deprecatedIllustrations].map((el) => el.getAttribute("src")),
          }),
        });
      }
    }
  });
} catch (e) {
  /*       */
}
